import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fix AR (2026-10-27): reservas de la pagina publica que el equipo todavia no vio. El numero junto a "Agenda" en el
// menu y el aviso de la agenda leen el mismo dato. El menu se monta dos veces (escritorio y celular): hay una sola
// consulta cada minuto, compartida.
const POLL_MS = 60000;
const store = { count: 0, latest: null, timer: null, subscribers: new Set() };

function publish() {
  const snapshot = { count: store.count, latest: store.latest };
  store.subscribers.forEach((fn) => fn(snapshot));
}

export async function refreshOnlineBookings() {
  try {
    const { data } = await api.get("/appointments/online-new");
    store.count = Number(data?.count) || 0;
    store.latest = data?.latest_at || null;
    publish();
  } catch {
    // silencioso: se reintenta en el proximo ciclo
  }
}

export function useOnlineBookings(enabled) {
  const [state, setState] = useState({ count: store.count, latest: store.latest });
  useEffect(() => {
    if (!enabled) return undefined;
    store.subscribers.add(setState);
    setState({ count: store.count, latest: store.latest });
    if (!store.timer) {
      refreshOnlineBookings();
      store.timer = setInterval(refreshOnlineBookings, POLL_MS);
    }
    return () => {
      store.subscribers.delete(setState);
      if (store.subscribers.size === 0) {
        clearInterval(store.timer);
        Object.assign(store, { timer: null, count: 0, latest: null });
      }
    };
  }, [enabled]);
  return state;
}
